import { render, staticRenderFns } from "./create-pshipping-page.vue?vue&type=template&id=5ea86f08&scoped=true&"
import script from "./create-pshipping-page.vue?vue&type=script&lang=js&"
export * from "./create-pshipping-page.vue?vue&type=script&lang=js&"
import style0 from "./create-pshipping-page.vue?vue&type=style&index=0&id=5ea86f08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea86f08",
  null
  
)

export default component.exports